import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import { Strings } from "../../resources/i18n/i18n";
import { loanApplicationFormInputs, NON_MANDATORY_REFERENCES_FIELDS, REFERENCE_FIELDS_OBJECT, REFERENCES_FIELDS } from "../CreateLoan/CreateLoanConstants";
import { NumericFormat } from "react-number-format";
class References extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            references: {
                comercialRef1: {
                    name: this.props.additionalInfo.comercialRef1.name,
                    address: this.props.additionalInfo.comercialRef1.address,
                    phone: this.props.additionalInfo.comercialRef1.phone
                },
                comercialRef2: {
                    name: this.props.additionalInfo.comercialRef2.name,
                    address: this.props.additionalInfo.comercialRef2.address,
                    phone: this.props.additionalInfo.comercialRef2.phone
                },
                personalRef1: {
                    name: this.props.additionalInfo.personalRef1.name,
                    address: this.props.additionalInfo.personalRef1.address,
                    phone: this.props.additionalInfo.personalRef1.phone
                },
                personalRef2: {
                    name: this.props.additionalInfo.personalRef2.name,
                    address: this.props.additionalInfo.personalRef2.address,
                    phone: this.props.additionalInfo.personalRef2.phone
                },
                neighbourhoodRef1: {
                    name: this.props.additionalInfo.neighbourhoodRef1.name,
                    address: this.props.additionalInfo.neighbourhoodRef1.address,
                    phone: this.props.additionalInfo.neighbourhoodRef1.phone
                },
                neighbourhoodRef2: {
                    name: this.props.additionalInfo.neighbourhoodRef2.name,
                    address: this.props.additionalInfo.neighbourhoodRef2.address,
                    phone: this.props.additionalInfo.neighbourhoodRef2.phone
                }
            },
            errorFieldArray: [],
            errorMessage: "",
        };

    }
    componentDidMount() {
        this.props.scrollToTop();
    }
    handleChange = (event, section) => {
        const { name, value } = event.target;
        this.setState(prevState => {
            const errorFieldArray = prevState.errorFieldArray?.filter(field => field !== `${section}-${name}`) || [];
            const errorMessage = errorFieldArray.length === 0 ? "" : prevState.errorMessage;
            return {
                errorFieldArray,
                errorMessage,
                references: {
                    ...prevState.references,
                    [section]: {
                        ...prevState.references[section],
                        [name]: value,
                    }
                }
            };
        });
    };


    renderNumberTextFields = (prop, section) => {

        const errorKey = `${section}-${prop.name}`;
        let errorClass = this.state?.errorFieldArray?.includes(errorKey) ? " error-data" : "";
        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <NumericFormat
                    name={prop.name}
                    className={"form-control w-100"}
                    onValueChange={(event) => {
                        const target = {
                            name: prop.name,
                            value: event.value ? event.value : "",
                        };
                        this.handleChange({ target }, section);
                    }}
                    allowLeadingZeros
                    value={this.state.references?.[section]?.[prop.name]}
                    type='text'
                    placeholder={Strings(prop.name)}
                    allowNegative={false}
                    disabled={prop.disabled || this.props.disableTextField}
                    isAllowed={
                        prop.isAllowed
                            ? prop.isAllowed
                            : () => {
                                return true;
                            }
                    }
                    maxLength={prop.maxLength}
                />
            </div>
        );
    };
    renderTextFields = (prop, section) => {

        const errorKey = `${section}-${prop.name}`;
        let errorClass = this.state?.errorFieldArray?.includes(errorKey) ? " error-data" : "";
        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <TextFieldComponent
                    id={prop.name}
                    type={prop.type}
                    className='noMargin'
                    placeholder={Strings(prop.name)}
                    value={this.state.references?.[section]?.[prop.name]}
                    handleChange={(event) => this.handleChange(event, section)}
                    name={prop.name}
                    disabled={prop.disabled || this.props.disableTextField}
                    maxLength={prop.maxLength}
                />
            </div>
        )
    }
    renderReferencesDetails = (editableData, section) => {
        return (
            <Row className='subHeaderApplication addOrUpdateUserFontSize ps-3'>
                {editableData.map((prop) => {
                    let renderTextField;
                    if (prop.type === "number") {
                        renderTextField = this.renderNumberTextFields(prop, section)
                    } else {
                        renderTextField = this.renderTextFields(prop, section)
                    }
                    return (
                        <Col
                            key={prop.name}
                            md={{ span: prop.md ? prop.md : 4 }}
                            className='ps-0 pe-3'
                        >
                            <Row>
                                <Col md={11}>
                                    <Row>
                                        <Col md={{ span: 12 }} className='px-0 pt-3'>
                                            <span className={prop.className ? prop.className : ""}>{Strings(prop.name)}</span>
                                            {prop.isMandatory && (
                                                <span className='mandatoryFields'>*</span>
                                            )}
                                        </Col>
                                        <Col
                                            md={{ span: 12 }}
                                            className={
                                                prop.name === "aid" ? "px-0 pt-4 textFieldComponent fullWidth" : "px-0 pt-2 textFieldComponent fullWidth"
                                            }
                                        >
                                            {renderTextField}
                                        </Col>
                                    </Row>

                                </Col>

                            </Row>
                        </Col>
                    );
                })}
            </Row>
        );
    };

    renderCommercialRef1 = () => {
        return (
            <>
                <Row>
                    <span className="createLoanSubHeadingText">{Strings("comercialRef1")}</span>
                </Row>
                {this.renderReferencesDetails(loanApplicationFormInputs.references.comercialRef1, REFERENCE_FIELDS_OBJECT.COMMERCIAL_REF_1)}
            </>
        )
    }
    renderCommercialRef2 = () => {
        return (
            <>
                <Row>
                    <span className="createLoanSubHeadingText pt-2">{Strings("comercialRef2")}</span>
                </Row>
                {this.renderReferencesDetails(loanApplicationFormInputs.references.comercialRef2, REFERENCE_FIELDS_OBJECT.COMMERCIAL_REF_2)}
            </>
        )
    }
    personalRef1 = () => {
        return (
            <>
                <Row>
                    <span className="createLoanSubHeadingText">{Strings("personalRef1")}</span>
                </Row>
                {this.renderReferencesDetails(loanApplicationFormInputs.references.personalRef1, REFERENCE_FIELDS_OBJECT.PERSONAL_REF_1)}
            </>
        )
    }
    personalRef2 = () => {
        return (
            <>
                <Row>
                    <span className="createLoanSubHeadingText pt-2">{Strings("personalRef2") + " (" + Strings("optional") + ") "}</span>
                </Row>
                {this.renderReferencesDetails(loanApplicationFormInputs.references.personalRef2, REFERENCE_FIELDS_OBJECT.PERSONAL_REF_2)}
            </>
        )
    }
    neighbourhoodRef1 = () => {
        return (
            <>
                <Row>
                    <span className="createLoanSubHeadingText">{Strings("neighbourhoodRef1")}</span>
                </Row>
                {this.renderReferencesDetails(loanApplicationFormInputs.references.neighbourhoodRef1, REFERENCE_FIELDS_OBJECT.NEIGHBOURHOOD_REF_1)}
            </>
        )
    }
    neighbourhoodRef2 = () => {
        return (
            <>
                <Row>
                    <span className="createLoanSubHeadingText pt-2">{Strings("neighbourhoodRef2") + " (" + Strings("optional") + ") "}</span>
                </Row>
                {this.renderReferencesDetails(loanApplicationFormInputs.references.neighbourhoodRef2, REFERENCE_FIELDS_OBJECT.NEIGHBOURHOOD_REF_2)}
            </>
        )
    }
    validateData = () => {
        if (this.props.disableTextField) {
            this.props.goNext();
            return;
        }
        const { references } = this.state;
        const errorFieldArray = [];
        let phoneLengthError = false;
        const referenceConfig = {
            comercialRef1: REFERENCES_FIELDS,
            comercialRef2: REFERENCES_FIELDS,
            personalRef1: REFERENCES_FIELDS,
            personalRef2: NON_MANDATORY_REFERENCES_FIELDS,
            neighbourhoodRef1: REFERENCES_FIELDS,
            neighbourhoodRef2: NON_MANDATORY_REFERENCES_FIELDS
        };
        Object.entries(referenceConfig).forEach(([section, fields]) => {
            fields.forEach(field => {
                const value = references?.[section]?.[field.name];
                if (field.name === "phone") {
                    if (field.isMandatory) {
                        if (!value) {
                            errorFieldArray.push(`${section}-${field.name}`);
                        } else if (value.length !== 10) {
                            errorFieldArray.push(`${section}-${field.name}`);
                            phoneLengthError = true;
                        }
                    } else if (value && value.length !== 10) {
                        errorFieldArray.push(`${section}-${field.name}`);
                        phoneLengthError = true;
                    }
                } else if (field.isMandatory) {
                    if (!value || value.trim().length === 0) {
                        errorFieldArray.push(`${section}-${field.name}`);
                    } else if (field.name === "phone" && value.length !== 10) {
                        errorFieldArray.push(`${section}-${field.name}`);
                    }
                }

            });
        });
        this.setState({ errorFieldArray });
        if (errorFieldArray.length === 0) {
            this.setState({
                errorFieldArray: [],
                errorMessage: ""
            });
            const isAllEmpty = obj =>
                !obj || Object.values(obj).every(val => val === null || val === undefined || val.trim().length === 0);
            const processedReferences = { ...this.state.references };
            ["personalRef2", "neighbourhoodRef2"].forEach(key => {
                if (isAllEmpty(processedReferences[key])) {
                    processedReferences[key] = null;
                }
            });
            this.props.callAPI(processedReferences, (errorMessage) => {
                this.setState({ errorMessage: errorMessage });
            });
        } else {
            this.setState({
                errorFieldArray,
                errorMessage: phoneLengthError ? Strings("telephoneNumberValidation") : Strings("pleaseSelectRequiredFields")
            });
        }
    };

    renderButtons = () => {
        return (
            <Row className='modalButton justify-content-between ps-3'>
                <Col md={2} className='text-start'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goBack}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>

                </Col>
                <Col md={4} className='d-flex justify-content-end pe-4'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goNext}
                        disabled={(!this.props.additionalInfo?.prefillData) || this.props.showLoadingModalState}
                    >
                        {Strings("Next").toUpperCase()}
                    </Button>
                    {!this.props.disableTextField && <Button
                        className={
                            "buttonBackground"
                        }
                        onClick={this.validateData}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("saveAndProceed")}
                    </Button>}
                </Col>
            </Row>
        )
    }
    renderErrors = () => {
        return (
            <Row>
                {this.state.errorMessage && (
                    <Col
                        md={12}
                        className='errors ps-2 ms-1'
                    >
                        {this.state.errorMessage}
                    </Col>
                )}
            </Row>
        )
    }
    render() {
        return (
            <Col md={12}>
                {this.renderErrors()}
                {this.renderCommercialRef1()}
                {this.renderCommercialRef2()}
                <hr className="opacity-100 mt-4 ms-2 me-2"></hr>
                {this.personalRef1()}
                {this.personalRef2()}
                <hr className="opacity-100 mt-4 ms-2 me-2"></hr>
                {this.neighbourhoodRef1()}
                {this.neighbourhoodRef2()}
                <hr className="opacity-100 mt-4 ms-2 me-2"></hr>
                {this.renderButtons()}
            </Col>
        )
    }
}
export default References;